import { createFileRoute, notFound } from '@tanstack/react-router';
import { TypeParam, isValidSubNav, isValidType, type SubnavParam } from './-utils';

type Params = {
  subNav: SubnavParam;
  type: TypeParam;
};

export const Route = createFileRoute('/bulk_/$subNav_/$type')({
  staticData: { team: 'fe-messaging' },
  params: {
    parse: (params): Params => {
      if (!isValidType(params.type)) {
        throw notFound();
      }
      if (!isValidSubNav(params.subNav)) {
        throw notFound();
      }
      return params as Params;
    },
  },
});
